<style>
.InfluencerJobShowPage .CampaignShowFull .CampaignImage {
    @apply m-0 rounded-t-lg;
}

@screen sm {
    .InfluencerJobShowPage .CampaignShowFull .CampaignImage {
        @apply rounded-none rounded-tl-lg;
    }
}
</style>
<script type="text/babel">
import HasSubscriptions from 'dashboard-js/mixins/HasSubscriptions'
import ManagesModalState from 'dashboard-js/mixins/ManagesModalState'
import RestoreOnPageBack from 'dashboard-js/mixins/RestoreOnPageBack'

export default {
    mixins: [ManagesModalState, HasSubscriptions, RestoreOnPageBack],

    props: ['job'],

    data() {
        return {
            componentKey: 0,
            submitStatusKey: 0,
            error: '',
            form: new SparkForm({}),
            editable: true,
            showJobContent: false,
            activeTab: null,
            localSubmittedPosts: '',
            visibleTabs: [],
            steps: {
                applied: {
                    label: 'Afvent svar',
                    headline: 'Sejt - din anmodning er sendt afsted',
                    emoji: '🚀',
                    description:
                        'Du har anmodet om jobbet, og det er nu op til virksomheden at godkende eller afvise din anmodning. Vi giver dig besked så snart vi ved mere.',
                },
                todo: {
                    label: 'Udarbejd materiale',
                    headline: 'Tillykke - du er nu godkendt!',
                    emoji: '🎉',
                    description:
                        'Du er nu godkendt og kan indsende materiale til godkendelse.',
                },
                inprogress: {
                    label: 'Første indhold er sendt',
                    headline: 'Super - du har sendt noget indhold afsted!',
                    emoji: '🤳',
                    description:
                        'Du har nu udarbejdet noget eller alt indhold. Du skal nu vente på om brandet godkender eller afviser indholdet. Hvis de afviser, så medfører det en kommentar på hvad de gerne vil have du ændre. I mellemtiden kan du udarbejde andet indhold i mens du venter.',
                },
                accepted: {
                    label: 'Udarbejd materiale',
                    headline: 'Tillykke - du er nu godkendt!',
                    emoji: '🎉',
                    description:
                        'Du er nu godkendt og kan indsende materiale til godkendelse.',
                },
                content_received: {
                    label: 'Indhold er sendt til godkendelse',
                    headline: 'Godt arbejde - dit indhold afventer godkendelse',
                    emoji: '🎉',
                    description:
                        'Dit indhold er nu sendt afsted til virksomheden. Vi giver dig besked når virksomheden har reageret på dit indhold.',
                },
                content_denied: {
                    label: 'Indhold afvist',
                    headline: 'Desværre - dit indhold blev afvist',
                    emoji: '🎉',
                    description:
                        'Dit indhold er blevet afvist af virksomheden. Se eventuelle kommentarer fra virksomheden og tag dialog med virksomheden. Når du er klar, indsend indhold på ny.',
                },
                started: {
                    label: 'Lav opslag',
                    headline: 'Fantastisk - dit indhold er godkendt og du kan påbegynde at lave opslag',
                    emoji: '🤳',
                    description:
                        'Du kan nu lave opslagene på dit medie. Efter du har lavet opslaget, bedes du indsætte et link til opslaget, hvorefter du vil modtage honoraret fra din <a href="/settings/billing">betterhype konto</a>, som bliver udbetalt hver 14. dag.',
                },
                finished: {
                    label: 'Færdig',
                    headline: 'Godt arbejde - jobbet er færdigt',
                    emoji: '💰',
                    description:
                        'Dit job er nu færdigt, og du vil modtage honoraret på din <a href="/settings/billing">betterhype konto</a>.',
                },
                declined: {
                    headline: 'Din anmodning blev afvist‍',
                    emoji: '🤷',
                    description:
                        'Din anmodning er blevet afvist. Op med humøret, og fortsæt det gode arbejde 💪.',
                },
                cancelled: {
                    headline: 'Samarbejdet er afbrudt‍',
                    emoji: '🚫',
                    description:
                        'Enten du eller virksomheden har valgt at afbryde samarbejdet. Du vil ikke modtage honorar, og vi anbefaler, at du ikke omtaler virksomheden på dit medie.',
                },
            },
        }
    },

    computed: {
        campaign() {
            return this.$get(this.job, 'jobable')
        },
        postContent() {
            if (!this.job) return

            let postContent = []
            for (var i = 0; i < this.job.posts; i++) {
                postContent.push({
                    number: i + 1,
                })
            }
            return postContent
        },
        currentActiveTab() {
            if (!this.activeTab) {
                const firstTab = Object.entries(this.job.submitted_posts).find(
                    ([key, value]) => key !== 'isCompleted' && value.data && value.data.length > 0
                )
                return firstTab ? firstTab[0] : null
            }
            return this.activeTab
        },
    },

    created() {
        Bus.$on('jobUpdated', job => {
            console.log('jobUpdated', job)
            
            this.job === null ? this.$set(this, 'job', job) : Object.assign(this.job, job)
            this.showJobContent = this.job.status !== 'applied' && this.job.status !== 'declined' && this.job.status !== 'cancelled'
            this.localSubmittedPosts = this.job.submitted_posts
            // this.updateVisibleTabs();
            // this.componentKey++
        })

        // this.job.submitted_posts = this.submitted_posts

        Bus.$on('approveContentMedia', data => {
            let type = data.postContent.post_type
            if (this.job.submitted_posts[type]) {
                // Update form_number status to submitted in data array
                let formNumberIdx = this.job.submitted_posts[type].data.findIndex(d => d.form_number === data.postContent.form_number+1)

                if (formNumberIdx >= 0) {
                    this.job.submitted_posts[type].data[formNumberIdx].status = 'approved_media'
                } else {
                    this.job.submitted_posts[type].data.push({
                        form_number: data.postContent.form_number+1,
                        status: 'approved_media'
                    })
                }

                // Update count of approved posts
                this.job.submitted_posts[type].count = this.job.submitted_posts[type].data.filter(item => item.status === 'approved_media').length
                this.submitStatusKey++;
            }
        })
    },

    methods: {
        submitPosts(job) {
            this.error = ''
            Spark.post(route('api.job.action', [job.id, 'submitPosts']), this.form).then(response => {
                if (response.error) {
                    this.error = response.error
                } else {
                    Bus.$emit('jobUpdated', response.data)
                }
            })
        },
        getFields(post_type) {
            const fieldMappings = {
                posts: [
                    { name: 'caption', label: 'Billedtekst', placeholder: '' },
                ],
                stories: [
                    { name: 'hashtag', label: 'Tekst', placeholder: '' },
                ],
                reels: [
                    { name: 'caption', label: 'Billedtekst', placeholder: '' },
                ],
                live: [],
                videos: [
                    { name: 'title', label: 'Titel', placeholder: '' },
                    { name: 'description', label: 'Beskrivelse', placeholder: '' },
                    { name: 'tags', label: 'Tags', placeholder: '' },
                ],
                sponsored: [
                    { name: 'title', label: 'Titel', placeholder: '' },
                    { name: 'description', label: 'Beskrivelse', placeholder: '' },
                    { name: 'tags', label: 'Tags', placeholder: '' },
                ],
                shorts: [
                    { name: 'music', label: 'Musik', placeholder: '' },
                    { name: 'title', label: 'Titel', placeholder: '' },
                    { name: 'hashtag', label: 'Hashtag', placeholder: '' },
                    { name: 'caption', label: 'Billedtekst', placeholder: '' },
                ],
                blog: [
                    { name: 'title', label: 'Titel', placeholder: '' },
                    { name: 'thumbnail', label: 'Miniaturebillede', placeholder: '' },
                ],
            }
            return fieldMappings[post_type] || []
        },

        isMedia(post_type) {
            const mediaTypes = {
                posts: true,
                stories: true,
                reels: false,
                live: false,
                videos: true,
                sponsored: true,
                shorts: false,
                blog: false,
            }
            return mediaTypes[post_type] || false
        },

        isFile(post_type) {
            const fileTypes = {
                live: true,
                blog: true,
            }
            return fileTypes[post_type] || false
        },
    },

    watch: {
        'job.status': {
            immediate: true,
            handler(newStatus) {
                this.showJobContent = newStatus !== 'applied' && newStatus !== 'declined' && newStatus !== 'cancelled'

                if (newStatus === 'content_received' || newStatus === 'started' || newStatus === 'finished' ) {
                    this.editable = false
                } else {
                    this.editable = true
                }
            }
        },
        'localSubmittedPosts': {
            immediate: true,
            deep: true,
            handler(newPosts, oldPosts) {
                const updatedPostType = Object.keys(newPosts).find(key => {
                    if (key === 'isCompleted') return false;
                    const newPostData = newPosts[key].data;
                    const oldPostData = oldPosts[key]?.data || [];
                    return newPostData.length > oldPostData.length;
                });

                // If a post type has been updated, set it as the active tab
                if (updatedPostType) {
                    this.activeTab = updatedPostType;
                }
            },
        },
        // activeTab(newTab) {
        //     this.updateVisibleTabs();
        // }
    },
}
</script>
